var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEstanciadeportiva(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Estancia_deportiva",
    "data-name": "Estancia deportiva",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 222.496,
    height: 214.188,
    viewBox: "0 0 222.496 214.188",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #7A4666;\n        stroke: #7A4666;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    className: "cls-1",
    width: 222.496,
    height: 214.188
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    className: "cls-1",
    d: "M1.789,89.925l-.006-.008A8.294,8.294,0,0,1,3.158,78.268L98.649,2.939a13.683,13.683,0,0,1,16.309-.475L217.686,74.218a8.294,8.294,0,0,1-9.5,13.6L115.565,23.127a13.683,13.683,0,0,0-16.309.475L13.438,91.3A8.294,8.294,0,0,1,1.789,89.925",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    className: "cls-1",
    d: "M223.954,316.131H122.471V266a4.249,4.249,0,0,0,.923.248h15.518a41.02,41.02,0,1,0,23.3-40.232l-8.33-12.624c-.017-.022-.044-.037-.059-.059l8.75-17.695a4.913,4.913,0,0,0-4.387-7.1H136.2a4.9,4.9,0,1,0,0,9.806h14.06l-4.432,9.071-50.713,0a5.492,5.492,0,0,0-.793-.825l5.228-11.027a4.9,4.9,0,0,0-4.427-7H68.729a4.9,4.9,0,1,0,0,9.806H87.374L74.921,224.635a40.815,40.815,0,1,0,27.762,38.783,41.008,41.008,0,0,0-18.944-34.525l5.721-12.063a.806.806,0,0,0,.145.027l21.548,34.231v65.021H15.643a4.9,4.9,0,0,0,0,9.809H223.957a4.9,4.9,0,1,0,0-9.79ZM93.509,263.438A31.709,31.709,0,1,1,61.656,231.58a31.337,31.337,0,0,1,9.252,1.534L57.854,260.658a4.9,4.9,0,0,0,2.327,6.523,4.829,4.829,0,0,0,2.1.484,4.9,4.9,0,0,0,4.427-2.81l13.064-27.568a31.82,31.82,0,0,1,13.737,26.151Zm86.25-32.207a31.693,31.693,0,1,1-31.5,35.022h31.379a4.909,4.909,0,0,0,4.093-7.609l-16.419-24.892a31.844,31.844,0,0,1,12.451-2.521Zm-20.723,7.782,11.493,17.423H148.552a31.4,31.4,0,0,1,10.484-17.423M148.76,223.459l5.119,7.75a40.675,40.675,0,0,0-14.6,25.227h-7.021Zm-47.348-6.229h39.5l-17.481,34.977-.96-1.539V235.578A5.654,5.654,0,0,0,111.6,233.4Z",
    transform: "translate(-6.365 -111.729)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstanciadeportiva);
export default __webpack_public_path__ + "static/media/Estancia deportiva.03fba64c2a9022ee9c109e7a65379cc2.svg";
export { ForwardRef as ReactComponent };